import React, { FunctionComponent, ReactNode } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';

export const PropertiesSection: FunctionComponent<{
  title: string;
  expanded: boolean;
  children: ReactNode;

  /** Optional icon rendered to the left of the title. */
  icon?: ReactNode;

  /**
   * Nesting depth. `0` (the default) renders a normal top-level section, untouched so existing consumers are unaffected;
   * a value greater than `0` recedes the section (inset, shaded, smaller title) so it reads as a child of the one above.
   */
  depth?: number;

  onExpand: () => void;
  onCollapse: () => void;
}> = (props) => {
  const depth = props.depth ?? 0;
  const isNested = depth > 0;

  const title = isNested ? (
    <Typography variant="body2" color="text.secondary">
      {props.title}
    </Typography>
  ) : (
    props.title
  );

  return (
    <Accordion
      expanded={props.expanded}
      onChange={() => {
        if (props.expanded) {
          props.onCollapse();
        } else {
          props.onExpand();
        }
      }}
      sx={
        isNested
          ? { ml: depth, bgcolor: 'action.hover', boxShadow: 'none', '&::before': { display: 'none' } }
          : undefined
      }
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {props.icon != null ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {props.icon}
            {title}
          </Box>
        ) : (
          title
        )}
      </AccordionSummary>
      <AccordionDetails>{props.children}</AccordionDetails>
    </Accordion>
  );
};
